let sr = {
  reveal: () => {},
};

// Only load ScrollReveal in browser
if (typeof window !== 'undefined') {
  import('scrollreveal')
    .then(ScrollRevealModule => {
      sr = ScrollRevealModule.default || ScrollRevealModule;
    })
    .catch(() => {
      // Silently fail if ScrollReveal not available
    });
}

export default sr;
